export const environment = {
  production: true,
  clientId: 'f3d78c21-c17e-4cc7-b812-cb1873377ff7'
};
